<div class="container specialist-catalog">
  <page-title [title]="title"></page-title>
  <p class="catalog-intro">Encontre o profissional e consulte os horários para iniciar este agendamento.</p>

  <div class="row busca">
    <div class="col-xs-12">
      <div class="search-container">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Busque por procedimento, especialista ou clínica</mat-label>
          <input
            type="text"
            matInput
            [formControl]="searchControl"
            (focus)="onInputFocus()"
            (blur)="onInputBlur()"
            (keydown)="onInputKeydown($event)"
            placeholder="Ex.: ecocardiograma, cardiologista ou clínica"
            autocomplete="off"
            role="combobox"
            aria-autocomplete="list"
            aria-controls="schedule-search-suggestions"
            [attr.aria-expanded]="showAutocompletePanel"
            [attr.aria-activedescendant]="activeSuggestionId"
            [attr.aria-describedby]="showAutocompleteHint ? 'schedule-search-hint' : null"
          />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>

        <mat-card *ngIf="showAutocompletePanel" id="schedule-search-suggestions" class="autocomplete-panel" role="listbox" aria-label="Sugestões de busca">
          <section *ngFor="let group of autocompleteSuggestionGroups" class="suggestion-group" role="group" [attr.aria-label]="group.category">
            <div class="suggestion-category">{{ group.category }}</div>
            <button
              type="button"
              *ngFor="let suggestion of group.suggestions"
              class="suggestion-item"
              role="option"
              [id]="getSuggestionId(suggestion)"
              [class.active]="isSuggestionActive(suggestion)"
              [attr.aria-selected]="isSuggestionActive(suggestion)"
              (mouseenter)="activateSuggestion(suggestion)"
              (mousedown)="$event.preventDefault()"
              (click)="selectSuggestion(suggestion)"
            >
              <mat-icon aria-hidden="true">{{ suggestion.mode === 'specialist' ? 'person' : suggestion.mode === 'clinic' ? 'local_hospital' : 'medical_services' }}</mat-icon>
              <span>{{ suggestion.label }}</span>
            </button>
          </section>
          <div *ngIf="visibleAutocompleteSuggestions.length === 0" class="autocomplete-empty" role="status" aria-live="polite">
            {{ loading ? 'Carregando sugestões…' : 'Nenhuma sugestão encontrada. Continue digitando para filtrar o catálogo.' }}
          </div>
        </mat-card>
        <small *ngIf="showAutocompleteHint" id="schedule-search-hint" class="search-hint">Digite ao menos 2 caracteres para ver sugestões.</small>
      </div>
    </div>

    <div class="col-xs-12 col-sm-10 col-md-9 col-lg-11 rangeBar">
      <mat-label for="distanceRange">Raio de busca: {{ formatLabel(distance) }}</mat-label>
      <mat-slider
        style="width: 100%"
        thumbLabel
        [displayWith]="formatLabel"
        tickInterval="10000"
        min="1000"
        max="500000"
        [(ngModel)]="distance"
        aria-label="Raio de busca em quilômetros"
      ></mat-slider>
    </div>

    <div class="col-xs-12 col-sm-2 col-md-3 col-lg-1 btBuscarRow">
      <button mat-flat-button color="primary" (click)="getProceduresNearest()" [disabled]="loading">
        <ng-container *ngIf="!loading">Buscar</ng-container>
        <ng-container *ngIf="loading">
          <mat-progress-spinner mode="indeterminate" diameter="20" strokeWidth="3"></mat-progress-spinner>
        </ng-container>
      </button>
    </div>

    <div *ngIf="latLong.length === 0" class="col-md-4">
      <button mat-stroked-button color="primary" (click)="getCurrentPosition()" class="text-center btAtivar">
        Ativar localização
      </button>
    </div>
  </div>

  <div class="catalog-mode-row">
    <span class="catalog-mode-label">Buscar por</span>
    <mat-button-toggle-group
      class="catalog-mode-toggle"
      [value]="activeSearchMode"
      aria-label="Escolha como buscar"
    >
      <mat-button-toggle value="procedure" (click)="navigateToMode('procedure')">
        <mat-icon aria-hidden="true">medical_services</mat-icon>
        Procedimento / Exame
      </mat-button-toggle>
      <mat-button-toggle value="specialist" (click)="navigateToMode('specialist')">
        <mat-icon aria-hidden="true">person</mat-icon>
        Especialista
      </mat-button-toggle>
      <mat-button-toggle value="clinic" (click)="navigateToMode('clinic')">
        <mat-icon aria-hidden="true">local_hospital</mat-icon>
        Clínica / Local
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <div *ngIf="search && search.length >= 2 && specialistGroups.length > 0" class="results-count" aria-live="polite">
    {{ specialistGroups.length }} {{ specialistGroups.length === 1 ? 'especialista encontrado' : 'especialistas encontrados' }}
  </div>

  <div *ngIf="loading" class="no-results" aria-live="polite">
    <mat-icon aria-hidden="true">search</mat-icon>
    <p>Buscando especialistas próximos…</p>
  </div>

  <div *ngIf="!loading && latLong.length > 0 && paginatedProcedures.length > 0" class="specialist-groups">
    <mat-card *ngFor="let group of paginatedProcedures; trackBy: trackBySpecialistGroup" class="specialist-card">
      <div class="specialist-card-heading">
        <img [src]="getPractitionerPhoto(group.practitionerId)" [alt]="'Foto de ' + group.name" />
        <button
          type="button"
          class="specialist-summary"
          (click)="togglePractitioner(group.practitionerId)"
          [attr.aria-expanded]="expandedPractitionerId === group.practitionerId"
        >
          <strong>{{ group.name }}</strong>
          <span>{{ getMainSpecialty(group.practitionerId) }}</span>
          <small>{{ group.clinicCount }} {{ group.clinicCount === 1 ? 'clínica' : 'clínicas' }}</small>
        </button>
        <button
          mat-stroked-button
          color="primary"
          class="about-specialist"
          (click)="openPractitionerInfos(group.practitionerId)"
        >
          Sobre o especialista
        </button>
        <button
          type="button"
          class="expand-specialist"
          (click)="togglePractitioner(group.practitionerId)"
          [attr.aria-label]="expandedPractitionerId === group.practitionerId ? 'Recolher serviços' : 'Ver serviços e locais'"
          [attr.aria-expanded]="expandedPractitionerId === group.practitionerId"
        >
          <mat-icon aria-hidden="true">{{ expandedPractitionerId === group.practitionerId ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
      </div>

      <div class="clinic-chips" *ngIf="expandedPractitionerId !== group.practitionerId">
        <span *ngFor="let clinic of getClinicsForPractitioner(group)">{{ clinic }}</span>
      </div>

      <div *ngIf="expandedPractitionerId === group.practitionerId" class="specialist-services">
        <article
          *ngFor="let procedure of group.procedures"
          class="specialist-service"
          [class.schedule-open]="expandedScheduleKey === getScheduleKey(procedure)"
        >
          <div class="service-summary">
            <div class="service-copy">
              <strong>{{ getServiceDisplayName(procedure) }}</strong>
              <span>{{ getClinicDisplayName(procedure) }}</span>
              <small>{{ getLocation(procedure.organization_id) || 'Endereço não informado' }}</small>
              <span class="service-price">
                {{ getHealthcarePaymentSummary(procedure.healthcareservice_id) }}
              </span>
            </div>
            <div class="service-actions">
              <button mat-button color="primary" (click)="openGoogleMapsLocation(procedure.organization_id)">
                <mat-icon>location_on</mat-icon>
                Mapa
              </button>
              <button mat-flat-button color="primary" (click)="toggleSchedule(procedure)">
                <mat-icon>{{ expandedScheduleKey === getScheduleKey(procedure) ? 'expand_less' : 'expand_more' }}</mat-icon>
                {{ expandedScheduleKey === getScheduleKey(procedure) ? 'Fechar horários' : 'Ver horários' }}
              </button>
            </div>
          </div>

          <div *ngIf="expandedScheduleKey === getScheduleKey(procedure)" class="schedule-panel">
            <schedule-specialist
              [healthcareservice]="procedure"
              [practitioner_id]="procedure.practitioner_id"
              [organization_id]="procedure.organization_id"
              (onSelectedDatetime)="onSelectedDatetime($event, procedure)"
            ></schedule-specialist>
          </div>
        </article>
      </div>
    </mat-card>
  </div>

  <div *ngIf="!loading && search.length >= 2 && specialistGroups.length === 0" class="no-results">
    <mat-icon aria-hidden="true">search_off</mat-icon>
    <p>Nenhum especialista encontrado para “{{ search }}”.</p>
  </div>

  <div *ngIf="hasSearched && !loading && procedures.length === 0" class="no-results">
    <mat-icon aria-hidden="true">location_off</mat-icon>
    <p>Nenhum especialista disponível nessa localização e raio.</p>
  </div>

  <div *ngIf="totalPages > 1" class="pagination-controls">
    <button mat-button color="primary" (click)="currentPage = currentPage - 1" [disabled]="currentPage === 0">
      Anterior
    </button>
    <span>Página {{ currentPage + 1 }} de {{ totalPages }}</span>
    <button mat-button color="primary" (click)="currentPage = currentPage + 1" [disabled]="currentPage === totalPages - 1">
      Próxima
    </button>
  </div>
</div>
